
import React, { useMemo } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeaderContent from './AccordionHeaderContent'
import PaymentProofCard from './PaymentProofCard'
import { getStepState } from '../utils/getStepState'
import IOrder from '@interfaces/IOrder'
import NotStartedStepMessage from './NotStartedStepMessage'

interface AccordionReceiptsVerificationProps {
  stepProgress: number
  inProgressOrder: IOrder | null
}

const AccordionReceiptsVerification: React.FC<AccordionReceiptsVerificationProps> = ({ stepProgress, inProgressOrder }) => {
  const stepState = getStepState(stepProgress)

  // Get file URLs and statuses from inProgressOrder
  const sampleProofUrl = inProgressOrder?.sample_payment_proof_url || null
  const sampleProofStatus = inProgressOrder?.sample_payment_proof_status || null
  const transportProofUrl = inProgressOrder?.transport_payment_proof_url || null
  const transportProofStatus = inProgressOrder?.transport_payment_proof_status || null

  const shippingPayment = inProgressOrder?.shipping_type
  const isShippingCompany = shippingPayment === 'shipping-company'

  // Transport payment not required for pro-seed and clinic
  const isTransportPaymentRequired = isShippingCompany

  const isUnlocked = useMemo(() => {
    return stepProgress > 0
  }, [stepProgress])

  return (
    <Accordion.Item eventKey="4" className={`${stepState}-state desabled`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Verificação de Pagamento"
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {!isUnlocked && (
            <NotStartedStepMessage />
          )}

          {isUnlocked && (
            <>
              <PaymentProofCard
                label="Comprovante da Amostra de Sêmen"
                proofStatus={sampleProofStatus}
                proofUrl={sampleProofUrl}
                icon="sample"
                uploadMode={false}
              />
              {isTransportPaymentRequired && (
                <PaymentProofCard
                  label="Comprovante da Transportadora"
                  proofStatus={transportProofStatus}
                  proofUrl={transportProofUrl}
                  icon="transport"
                  uploadMode={false}
                />
              )}
            </>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionReceiptsVerification
